import React, { useEffect, useState } from 'react'
import classnames from 'classnames'

import { sendTeaCommEvent } from 'lib/tea-analyze'

import PriceInput from './price-input'
import { ContextStore } from './reducer'
import { IOptionProps, IConditionsProps, ISortProps } from './interface'

interface Props {
  conditions: IConditionsProps[]
  /* 展示更多条件下面的线 */
  hideline?: boolean
}

type subCondition = {
  text: string
  key: string
  param: number
}
export default function Conditions({ conditions }: Props) {
  /* 判断是否是条件的请求 */
  // const { dispatch } = React.useContext(ContextStore)
  const { state, dispatch } = React.useContext(ContextStore)
  const [subConditions, setSubConditions] = useState<subCondition[]>([])
  const [fuel, setFuel] = useState<ISortProps>({
    text: '新能源',
    sub_options: [
      {
        text: '全部',
        key: 'all_sub_options',
        param: -1,
      },
      {
        text: '纯电动',
        key: 'fuel_form',
        param: 4,
      },
      {
        text: '插电式混合动力',
        key: 'fuel_form',
        param: 6,
      },
      {
        text: '增程式',
        key: 'fuel_form',
        param: 5,
      },
    ],
    param: '4,6,5',
    key: 'fuel_form',
  })

  useEffect(() => {
    if (Object.keys(state).length === 0) {
      setSubConditions([])
    }
  }, [state])

  const allConditionKeys = React.useMemo(() => {
    return conditions.map(item => {
      return Array.from(
        new Set(item.data.map(item => item.key).filter(item => !!item))
      )
    })
  }, [conditions])
  function getStat(options: any) {
    return Object.keys(options).reduce((acc: any, curr: string) => {
      acc[curr] = options[curr].map((item: any) => item.param).join(',')
      return acc
    }, {})
  }
  const handleOptionClick = (item: ISortProps, line: number) => {
    // 第N行条件
    const currentLine = allConditionKeys[line]
    // dispatch({ type: 'conditions' })
    const newOptions = Object.assign({}, state)

    // 选择不限时，清空整行元素
    if (item.text.indexOf('不限') >= 0) {
      currentLine.forEach(key => {
        newOptions[key] = []
      })
      dispatch({
        type: 'resetOptions',
        payload: newOptions,
      })
      setSubConditions([])
      return
    }

    if (item.text.indexOf('全部') >= 0 && item.key !== 'fuel_form') {
      currentLine.forEach(key => {
        newOptions.outter_detail_type = []
      })
      dispatch({
        type: 'resetOptions',
        payload: newOptions,
      })
      return
    }

    if (item.key === 'series_type') {
      if (item.sub_options) {
        setSubConditions(item.sub_options)
      } else {
        setSubConditions([])
      }
      dispatch({
        type: 'resetOptions',
        payload: {
          ...newOptions,
          new_energy: [],
          fuel_form: [],
          outter_detail_type: [],
        },
      })
      dispatch({
        type: 'setSingleOption',
        payload: item,
      })
      return
    }

    if (item.key === 'new_energy') {
      setFuel(item)
      if (item.sub_options) {
        try {
          item.sub_options[0].key = 'fuel_form'
        } catch (e) {
          console.error(e)
        }
        setSubConditions(item.sub_options)
      }
      dispatch({
        type: 'resetOptions',
        payload: {
          ...newOptions,
          series_type: [],
          fuel_form: [],
          outter_detail_type: [],
        },
      })

      dispatch({
        type: 'setSingleOption',
        payload: item,
      })
      return
    }

    if (item.key === 'fuel_form') {
      // 点击全部
      if (item.text.indexOf('全部') >= 0) {
        dispatch({
          type: 'resetOptions',
          payload: { ...newOptions, fuel_form: [] },
        })
        return
      }
      // 从没有子选项到新增第一个子选项
      if (newOptions.fuel_form.length === 0) {
        newOptions.fuel_form = [item]
        dispatch({
          type: 'resetOptions',
          payload: { ...newOptions, fuel_form: newOptions.fuel_form },
        })
        return
      }
      // 新增子选项或删除子选项
      if (newOptions.fuel_form?.length !== 0) {
        if (newOptions.fuel_form.some(option => option.param === item.param)) {
          newOptions.fuel_form = newOptions.fuel_form.filter(
            option => option.param !== item.param
          )
          dispatch({
            type: 'resetOptions',
            payload: { ...newOptions, fuel_form: [...newOptions.fuel_form] },
          })
          return
        } else {
          newOptions.fuel_form = newOptions.fuel_form.filter(
            option => option.param !== item.param
          )
          dispatch({
            type: 'resetOptions',
            payload: {
              ...newOptions,
              fuel_form: [...newOptions.fuel_form, item],
            },
          })
          return
        }
      }
      dispatch({
        type: 'resetOptions',
        payload: {
          fuel_form: [...newOptions.fuel_form, item],
        },
      })
    }

    // 初始值为空
    if (!newOptions[item.key]) {
      newOptions[item.key] = []
    }
    if (newOptions[item.key].some(option => option.param === item.param)) {
      // 已存在
      newOptions[item.key] = newOptions[item.key].filter(
        option => option.param !== item.param
      )
    } else {
      // 不存在
      newOptions[item.key].push({
        text: item.text,
        param: item.param,
      })
    }
    // sendTeaCommEvent('click_garage_series_selector', getStat(newOptions))
    dispatch({
      type: 'resetOptions',
      payload: newOptions,
    })
  }
  function isOptionActive(option: ISortProps, line: number): boolean {
    if (!option) {
      return false
    }
    // 不限的高亮条件：同一行中没有被选中的元素
    if (option.text === '不限') {
      return !allConditionKeys[line].some(
        item => !!state[item] && state[item].length > 0
      )
    }

    if (option.text === '全部') {
      if (!state.fuel_form) {
        return true
      }
      if (!state.outter_detail_type) {
        return true
      }
      return (
        state.outter_detail_type.length === 0 && state.fuel_form.length === 0
      )
    }

    if (!state[option.key] || !state[option.key].length) {
      return false
    }
    // ===部分条件筛选有问题
    if (state[option.key].some(item => item.param == option.param)) {
      return true
    }
    return false
  }

  return (
    <React.Fragment>
      <h2>条件筛选</h2>
      <section style={{ marginBottom: '24px' }}>
        {conditions.map((data: IConditionsProps, line: number) => {
          return (
            <div className="conditions clearfix" key={data.title}>
              <span className="label fl">{data.title}：</span>
              {data.data.map((item: ISortProps) => {
                const active = isOptionActive(item, line)
                if (item.key === 'price' && item.text === '输入框') {
                  return (
                    <div className="condition-input">
                      <PriceInput key={item.text} onClick={handleOptionClick} />
                    </div>
                  )
                }
                return (
                  <span
                    key={item.text}
                    role="button"
                    className={classnames('condition', {
                      active,
                    })}
                    onClick={event => {
                      event.stopPropagation()
                      handleOptionClick(item, line)
                    }}
                  >
                    {item.text}
                    {active && item.text !== '不限' && (
                      <div className="active_mark" />
                    )}
                  </span>
                )
              })}
            </div>
          )
        })}
        <div style={{ marginLeft: '56px' }}>
          {subConditions.map((item, line) => {
            return (
              <span
                key={item.text}
                role="button"
                className={classnames('condition', {
                  active: isOptionActive(item, line),
                })}
                onClick={event => {
                  event.stopPropagation()
                  handleOptionClick(item, line)
                }}
              >
                {item.text}
              </span>
            )
          })}
        </div>
      </section>
      <style jsx>
        {`
          h2 {
            line-height: 60px;
            font-size: 24px;
            font-weight: 500;
          }
          .conditions {
            padding: 0 0 12px;
            border-bottom: 1px dashed #ededed;
          }
          .label {
            line-height: 28px;
            color: #666;
            margin-top: 10px;
          }
          .condition {
            display: inline-block;
            margin: 12px 2px 0;
            padding: 4px 8px;
            cursor: pointer;
            border-radius: 2px;
            transition: all 0.1s ease-in-out;
          }
          .condition:hover {
            background: #fff5d6;
          }
          .condition-input {
            display: inline-block;
            margin-top: 12px;
          }
          .active {
            position: relative;
            background-color: #ffcd32;
          }
          .active_mark {
            position: absolute;
            right: 0;
            left: 0;
            margin: 0 auto;
            margin-top: 7px;
            width: 20px;
            min-width: 20px;
            height: 10px;
            background-image: url(${require('static/active-icon-pic.svg')});
            background-size: cover;
          }
          .active:hover {
            color: #1a1a1a;
            background-color: #ffcd32;
          }
        `}
      </style>
    </React.Fragment>
  )
}
